import React, { CSSProperties } from 'react';
import { Box, Container, Typography, useMediaQuery } from '@mui/material';
import { motion as Motion } from "framer-motion";
import Individual from './individual';
import Coletivo from './coletivo';
import Empresarial from './empresarial';

export const styleTitle: CSSProperties = {
  color: "#004387"
}
export const styleImage: CSSProperties = {
  width: "100%",
}

const HealthPlanComponent: React.FC<{ setPlanoAtual(newValue: string): void }> = ({ setPlanoAtual }) => {

  const isMobile = useMediaQuery("(max-width:768px)");
  
  return (
    <Box>
   
      <Container>
        <Typography variant={isMobile? "h6" : 'h5'} gutterBottom>Planos sob medida para cada necessidade </Typography>
        <Typography variant='body1' textAlign="justify">
          No Innova, entendemos que cada pessoa e empresa tem necessidades únicas de 
          cuidado. Por isso, nossos planos são pensados para se adaptar ao seu estilo de 
          vida e atender aos diferentes momentos da vida de cada beneficiário. 
        </Typography>
      </Container> 
      <Motion.div
        initial={{ opacity: 0, x: -100}}
        whileInView={{ opacity: 1, x: 0}}
        exit={{ opacity: 0, x: -100}}
        transition={{ duration: 0.5}}
      >
        <Individual setPlanoAtual={setPlanoAtual}/>
      </Motion.div>
      <Motion.div
          initial={{ opacity: 0, x: -100}}
          whileInView={{ opacity: 1, x: 0}}
          exit={{ opacity: 0, x: -100}}
          transition={{ duration: 0.5}}
      >
        <Coletivo setPlanoAtual={setPlanoAtual}/>
      </Motion.div>
      <Motion.div
        initial={{ opacity: 0, x: -100}}
        whileInView={{ opacity: 1, x: 0}}
        exit={{ opacity: 0, x: -100}}
        transition={{ duration: 0.5}}
      >
        <Empresarial setPlanoAtual={setPlanoAtual}/>
      </Motion.div>

      
    </Box>
  );
};

export default HealthPlanComponent;
